import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`

export const Col = styled.div`
    display: flex;
    flex-direction: column;
    align-items: self-start;
    flex: 1;
    width: 100%;
`

export const MobileNumberBox = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
`

export const MobileInputValidation = styled.div`
    color: var(--oh-orange);
    font-size: 10px;
    margin: 0px 0px 5px 4px;
    visibility: ${p => (p.invalid ? 'visible' : 'hidden')};
`

export const OTPValidation = styled.div`
    color: var(--oh-orange);
    font-size: 10px;
    margin: 4px 0 10px 0;
    visibility: ${p => (p.invalid ? 'visible' : 'hidden')};
`

export const MobileInput = styled.input`
    height: 30px;
    width: 100%;
    width: -moz-available; /* WebKit-based browsers will ignore this. */
    width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
    width: fill-available;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 16px;
    margin: 10px 0px;
    font-family: AvenirBold;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    color: #666666;
    outline: 0 !important;
    border: 1px solid ${p => (p.invalid ? '#ef5c34' : '#E0E0E0')};

    ::placeholder {
        color: #c4c4c4;
    }

    @media (max-width: 360px) {
        margin: 8px 0;
        padding: 4px 5px;
    }
`

export const OtpButton = styled.div`
    background: ${p => (p.isDisabled ? 'var(--oh-disabled)' : '#66b5de')};
    pointer-events: ${p => (p.isDisabled ? 'none' : 'initial')};
    border: 1px solid rgba(102, 181, 222, 0.05);
    box-sizing: border-box;
    border-radius: 4px;
    height: 47px;
    width: 30%;
    margin: 10px 0px 10px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    cursor: pointer;
    font-size: 14px;
    text-align: center;

    @media (max-width: 810px) {
        font-size: 0.9rem;
    }
    @media (max-width: 700px) {
        margin: 10px 0px 10px 10px;
    }
    @media (max-width: 500px) {
        font-size: 12px;
        line-height: 140%;
    }

    @media (max-width: 360px) {
        margin: 8px 0px 8px 8px;
        height: 40px;
    }
`

export const OtpInput = styled(MobileInput)``

export const Title = styled.div`
    font-size: 1.7rem;
    font-weight: bold;
    font-family: AvenirBold;
    color: #333333;
    line-height: 120%;
`

export const Orange = styled.span`
    color: var(--oh-orange);
`

export const Spam = styled.label`
    font-size: 1.3rem;
    color: #333333;
    font-family: Avenir;
    margin: 0.5rem 0 30px;
`

export const Signup = styled(Spam)`
    display: flex;
    flex-direction: row;
    margin: 30px 0;
    font-size: 1rem;

    @media (max-width: 360px) {
        margin: 20px 0;
    }
`

export const StyledLink = styled(Link)`
    text-decoration: none;
`

export const SignupLink = styled.span`
    margin-left: 5px;
    color: var(--oh-orange);
    font-family: AvenirBold;
    display: flex;
    flex-direction: row;
    align-items: center;
`

export const LoginButton = styled.div`
    background: ${p =>
        p.isDisabled ? 'var(--oh-disabled)' : 'var(--oh-teal)'};
    border: 1px solid rgba(102, 181, 222, 0.05);
    box-sizing: border-box;
    border-radius: 4px;
    color: white;
    font-weight: bold;
    height: 40px;
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;

    @media (max-width: 700px) {
        font-size: 16px;
        width: 100%;
    }
`

export const RightArrow = styled.div`
    height: 1rem;
    width: 1rem;
    margin-left: 5px;
    background: url('/assets/right-arrow.svg') center center no-repeat;
    background-size: contain;
`

export const FormWrapper = styled.div`
    width: 100%;
`
